import { SELLER_PATH } from "../../../origin";

export const greens_config = [
  { zh_title: '山药', en_title: 'Yam' },
  { zh_title: '大蒜', en_title: 'Garlic' },
  { zh_title: '番茄', en_title: 'Tomato' },
  { zh_title: '土豆', en_title: 'Potato' },
  { zh_title: '黄瓜', en_title: 'Cucumber' },
  { zh_title: '胡萝卜', en_title: 'Carrot' },
  { zh_title: '生姜', en_title: 'Ginger' },
  { zh_title: '大葱', en_title: 'Welsh Onion' },
  { zh_title: '洋葱', en_title: 'Onion' },
  { zh_title: '大白菜', en_title: 'Cabbage' },
  { zh_title: '长白萝卜', en_title: 'Radish' },
  { zh_title: '西兰花', en_title: 'Broccoli' },
];
export const fruit_config = [
  { zh_title: '桃子', en_title: 'Peach' },
  { zh_title: '沃柑', en_title: 'Orah Mandarin' },
  { zh_title: '褚橙', en_title: 'Orange' },
  { zh_title: '柠檬', en_title: 'Lemon' },
  { zh_title: '苹果', en_title: 'Apple' },
  { zh_title: '荔枝', en_title: 'Lychee' },
  { zh_title: '蜜柚', en_title: 'Honey Pomelo' },
  { zh_title: '砀山梨', en_title: 'Dangshan Pear' },
  { zh_title: '哈密瓜', en_title: 'Hami Melon' },
  { zh_title: '西瓜', en_title: 'Watermelon' },
  { zh_title: '阳光玫瑰', en_title: 'Shine-Muscat grape' },
  { zh_title: '沃柑', en_title: 'Orah Mandarin' },
  { zh_title: '赣南脐橙', en_title: 'Gannan navel orange' },

];
export const link_config = [
  {zh_title:'进入个人中心', en_title:'Enter The Buyer Center', href:'/basic/user/order', target:'_self'},
  {zh_title:'进入供应商中心', en_title:'Enter The Seller Center',href:`${SELLER_PATH}/404`, target:'_blank'},
];